import {
  customFormChangeSuccess,
} from "../../../utils/reducerOperations";


export function handleExportFormChange(state, payload) {
  return customFormChangeSuccess({ state: state, key: 'exportFormConfiguration' }, payload);
}

